<template>
  <div
    id="app"
    :style="{ 'min-height': minHeight, 'background-color': '#fff' }"
    v-if="showBool"
  >
    <router-view v-slot="{ Component }">
      <!-- v-if 控制是否启用缓存 -->
      <keep-alive>
        <component :is="Component" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <!-- 不需要缓存的组件 -->
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
</template>

<script setup lang="ts">
import {
  appInfo,
  formateUrl,
  authWxOpenFunc,
  getLoginInfo,
  getAppGtoken,
  callHybridHandle,
  wxShare,
  generateRandomString,
  showBtn,
  nShare,
  setTitle,
} from "@eastmoney/mku";
import _envObj from "@/utils/env";
import { getActConfigInfo } from "@/utils/common";
import { $loading, $toast } from "@/utils/globalUtils";
let _entryUrl = "";

/** data */
import { ref } from "vue";
const minHeight = ref("");
const showBool = ref(false);
const userObj = ref({});
const osv = ref(""); // ios系统版本
const model = ref(""); // 手机版本
const configObj = ref({});

/** pinia */
import { useMainStore } from "@/pinia/main";
const { setUserInfo } = useMainStore();

/** router */
import { useRouter } from "vue-router";
const router = useRouter();

/************************************************** lifecircle **************************************************/

/** created */
const onCreated = async () => {
  _entryUrl = window.location.href;
  minHeight.value = window.innerHeight + "px";
};
onCreated();

/** mounted */
import { onMounted } from "vue";
onMounted(() => {
  initDataMed();
  initWebviewReLoad();
});

/************************************************** methods **************************************************/
/**
 * App内webview重载控制(解决页面长期处于后台时，webview被系统挂起空白的问题)
 */
function initWebviewReLoad() {
  appInfo.inApp(() => {
    // 东财App内
    if (appInfo.isIOS) {
      let jsonStr = {
        open: 1,
      };
      setTimeout(() => {
        console.log("调用allowsTerminateBlankReload");
        if (window && window.eastmoney) {
          window.eastmoney.allowsTerminateBlankReload?.(
            JSON.stringify(jsonStr),
          );
        }
      }, 3000);
    }
  });
}

/** 页面初始化 */
const initDataMed = () => {
  appInfo.inApp(
    () => {
      // 在app中
      console.log("在app中", window.location.href);
      getConfigMed();
      routerHandleInApp();
    },
    () => {
      // 在app外
      console.log("在app外");
      routerHandleOutApp();
    },
  );
};

/******************** 站内逻辑 start ********************/

/** 站内路由 */
const routerHandleInApp = () => {
  getDeviceInfoMed();
};
// 获取配置信息
const getConfigMed = () => {
  getActConfigInfo((respdata: any) => {
    configObj.value = respdata;
    appInfo.inApp(
      () => {
        // 东财App内
        initAppShare(respdata);
      },
      () => {
        // App外
        if (appInfo.isWeChat) {
          initWxShare(respdata);
        }
      },
    );
  });
};
const initAppShare = (_configObj: any = null) => {
  showBtn({
    type: "share",
    enable: 1, // 为0的时候，按钮不可用
    btntext: "分享",
    cb: () => {
      let _url = _envObj?.actIndexUrl + "/index" + generateRandomString();
      let _title = _configObj["shareTitle"];
      let _desc = _configObj["shareSubtitle"];
      let _img = _configObj["shareImage"];
      // 分享
      nShare({
        type: "weixin,pengyouquan,qq,qzone,weibo",
        title: _title, // 分享卡片标题
        img: _img, // 分享卡片图标链接
        url: _url, // 点击卡片跳转的页面链接
        desc: _desc, // 分享卡片描述，即副标题
        callback: (res: any) => {
          if (res == "error") {
            // 未安装
            $toast.show("分享失败，请先查看是否已安装相应的App哦～");
          } else if (res == "cancel") {
            // 用户取消
          } else {
            // 分享成功
          }
        },
      });
    },
  });

  setTimeout(() => {
    setTitle("东方财富妙想Skills");
  }, 50);
};
/** 获取设备信息 */
const getDeviceInfoMed = () => {
  const _obj: any = {};
  // 获取gtoken
  getAppGtoken((res: any) => {
    let _gtoken = "";
    if (res && res["data"] && res["data"]["gToken"]) {
      _gtoken = res["data"]["gToken"];
    }
    // 获取到gtoken信息
    _obj["gtoken"] = _gtoken;
    // 设备信息
    let deviceInfo: any = {};
    // 应用信息
    let appData: any = {};
    // 获取设备信息
    callHybridHandle({
      moduleName: "Container", // 模块
      methodName: "getDeviceInfo", // 方法名
      requestJson: {},
      callback: (res: any) => {
        // 调用成功后返回
        deviceInfo = res && res["data"];
        console.log("获取到的设备信息啥的有", deviceInfo);
        osv.value =
          (deviceInfo && deviceInfo["osv"]) || deviceInfo["osVersion"];
        model.value = deviceInfo && deviceInfo["model"];
        if (appInfo.isIOS) {
          setUserInfo({ deviceid: deviceInfo["idfv"] });
        } else {
          setUserInfo({ deviceid: deviceInfo["euid"] });
        }
        callHybridHandle({
          moduleName: "Container",
          methodName: "getApplicationInfo",
          requestJson: {},
          callback: (res: any) => {
            appData = res && res["data"];
            console.log("获取应用信息啥的", appData);
            _obj["EM-MD"] = deviceInfo["uniqueId"];
            _obj["EM-OS"] = deviceInfo["osv"] || deviceInfo["osVersion"];
            _obj["EM-VER"] = appData["appVersionName"] || appData["appversion"];
            // 版本
            (window as any).clientVersion =
              appData["appVersionName"] || appData["appversion"];
            // 设备信息获取之后，获取通行证信息
            console.log("获取到的设备信息，", _obj);
            getUserInfoMed(_obj);
          },
        });
      },
    });
  });
};

/** 站内登录通行证 */
const getUserInfoMed = (_obj: any) => {
  // app内 获取用户信息
  getLoginInfo(
    (res: any) => {
      if (typeof res === "string") {
        res = JSON.parse(res);
      }
      console.log("通行证已登录", res);
      initUserInfo(res, _obj);
    },
    () => {
      _obj["haslogin"] = false;
      let _userObj = Object.assign({}, _obj);
      _obj["userObj"] = _userObj;
      console.log("通行证未登录", _obj);
      setUserInfo(_obj);
      // 未登录处理页面跳转
      let _pathName = window.location.pathname;
      showBool.value = true;
    },
  );
};

/** 设置用户信息并获取状态 */
const initUserInfo = (res: any, _obj: any) => {
  _obj["ct"] = res["data"]["ct"];
  _obj["ut"] = res["data"]["ut"];
  _obj["uid"] = res["data"]["uid"];
  _obj["nickname"] = decodeURIComponent(
    decodeURIComponent(res["data"]["nickname"]),
  );
  _obj["hasSecurities"] = res["data"]["hasSecurities"];
  _obj["haslogin"] = true;
  const _userObj = Object.assign({}, _obj);
  _obj["userObj"] = _userObj;
  userObj.value = _userObj;
  setUserInfo(_obj);
  const _pathName = window.location.pathname;
  showBool.value = true;
};

/******************** 站内逻辑 end ********************/

/******************** 站外逻辑 start ********************/

/** 站外路由 */
const routerHandleOutApp = () => {
  if (appInfo.isWeChat) {
    console.log("调用微信授权");
    // 微信中
    try {
      authWxOpenFunc(
        (res: any) => {
          console.log("微信授权", res);
          if (res && res["status"] === 0) {
            // 权限注入成功，后续可进行微信分享设置、开放标签功能调用等
            console.log("微信权限注入成功", res);
            setUserInfo({ hasAuth: true });
          } else {
            // 权限注入失败，失败原因在res['data']中
            setUserInfo({ hasAuth: false });
          }
          transferRoute();
        },
        {
          url: _entryUrl,
        },
      );
    } catch (err) {
      console.log("微信授权error===", err);
      setUserInfo({ hasAuth: false });
      transferRoute();
    }
  } else {
    transferRoute();
  }
};

/** 站外路由切换 */
const transferRoute = () => {
  const _pathName = window.location.pathname;
  console.log(_pathName);
  if (/mykeys/gi.test(_pathName)) {
    linkNextRoute("/outindex");
  } else {
    showBool.value = true;
  }
  getConfigMed();
};

/** 设置微信分享 */
const initWxShare = (_configObj: any = null) => {
  let resp = null;
  if (!_configObj) {
    resp = configObj.value as any;
  } else {
    resp = _configObj as any;
  }
  if (appInfo.isWeChat) {
    if (resp) {
      let _title;
      let _desc;
      let _img;
      let _url = _envObj?.actIndexUrl + "/index" + generateRandomString();
      // 普通分享
      _title = resp["shareTitle"];
      _desc = resp["shareSubtitle"];
      _img = resp["shareImage"];
      const _shareObj = {
        title: _title, // 分享卡片标题
        img: _img, // 分享卡片图标
        url: _url, // 点击卡片跳转的页面url
        desc: _desc, // 卡片描述
      };
      console.error("普通微信分享内容：", _shareObj);
      wxShare(_shareObj);
    }
  }
};

/** 跳转到下一路由（避免同页二次导航导致重复上报） */
const linkNextRoute = (_path: string, query: any = {}) => {
  try {
    const current = router.currentRoute.value as any;
    const mergedQuery = { ...formateUrl(), ...query } as any;
    // 若当前已在 Maintain 页面（无论路径为 /index 或 /maintain），避免再次 replace 触发路由守卫
    if (current && current.name === "Maintain") {
      const resolved = router.resolve({
        path: current.path,
        query: mergedQuery,
      });
      const targetHref = resolved.href;
      const currentHref = router.resolve({
        path: current.path,
        query: current.query,
      }).href;
      // 仅在 query 发生变化时使用 history.replaceState 更新地址，避免触发 afterEach
      if (targetHref !== currentHref) {
        window.history.replaceState(null, "", targetHref);
      }
      showBool.value = true;
      return;
    }

    console.log("跳转到下一路由", _path);
    router.replace({ path: _path, query: mergedQuery });
    setTimeout(() => {
      showBool.value = true;
    }, 100);
  } catch (e) {
    // 兜底：异常情况下仍保证页面可展示
    showBool.value = true;
  }
};

/******************** 站外逻辑 end ********************/
</script>

<style lang="scss">
#app {
  user-select: none;
  background-color: white;
}

#app::-webkit-scrollbar {
  display: none;
}
html,
body,
div,
a,
button {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
